import { render } from "./ClassTaskContent.vue?vue&type=template&id=7d08be37&scoped=true"
import script from "./ClassTaskContent.vue?vue&type=script&lang=js"
export * from "./ClassTaskContent.vue?vue&type=script&lang=js"

import "./ClassTaskContent.vue?vue&type=style&index=0&id=7d08be37&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d08be37"]])

export default __exports__